<template>
  <div>
    <QForm @submit.prevent="onSubmit">
      <div class="row">
        <div style="background-color: var(--primary-color-background); padding: 20px">
          <h5>Requirements</h5>
          <b>Your identity needs to be verified</b>
          <!-- <p>
            To verify your identity electronically with a verification service / credit reporting body, we’ll need you to upload a copy of
            the front and back of your Driver’s Licence.
          </p> -->
          <p>
            So that we can verify your identity electronically with a verification service / credit reporting body, we’ll need you to upload
            a copy of the front and back of your Driver’s Licence.
          </p>
          <ul>
            <li>
              Device with a camera (Preferred method mobile device)
              <img
                src="/assets/icons/small-info.svg"
                :style="convertColourComputed ? convertColourComputed : ''"
                alt="A device with a camera is needed to scan your identity document and capture its details."
                title="A device with a camera is needed to scan your identity document and capture its details."
                style="cursor: pointer; vertical-align: middle; margin: 0 0 0 3px; color: var(--primary-color)"
                @click="openDialog('device')"
              />

              <!-- <img
                src="/assets/icons/small-info.svg"
                alt="A device with a camera is needed to scan your identity document and capture its details."
                title="A device with a camera is needed to scan your identity document and capture its details."
                style="cursor: pointer; vertical-align: middle; margin: 0 0 0 3px"
                @click="openDialog('device')"
              /> -->
            </li>
            <li>
              Identification documents
              <img
                src="/assets/icons/small-info.svg"
                :style="convertColourComputed ? convertColourComputed : ''"
                alt="Your current driver's licence will be needed to verify your identity."
                title="Your current driver's licence will be needed to verify your identity."
                style="cursor: pointer; vertical-align: middle; margin: 0 0 0 3px; color: var(--primary-color)"
                @click="openDialog('identity')"
              />
              <!-- <img
                src="/assets/icons/small-info.svg"
                alt="Your current driver's licence will be needed to verify your identity."
                title="Your current driver's licence will be needed to verify your identity."
                style="cursor: pointer; vertical-align: middle; margin: 0 0 0 3px"
                @click="openDialog('identity')"
              /> -->
            </li>
            <li>Where nominated, other authorised officers will be contacted to verify their identity.</li>
          </ul>
        </div>
        <br />
        <div class="row items-center">
          <!-- <div class="col-xs-2 col-sm-2 col-md-1">
            <QCheckbox v-model="checked" />
          </div> -->
          <!-- <div class="col-xs-10 col-sm-10 col-md-11">
            I agree to proceed with the electronic identity verification check and understand that my details will be used and held in
            accordance with the FleetPartners <a :href="privacyPolicy" target="_blank">Privacy Policy</a>.
          </div> -->

          <div style="padding: 20px">
            <b>Your agreement</b>
            <p>By clicking the "Continue" button, I:</p>
            <ul>
              <li>
                acknowledge that I have read the
                <a :href="consentUrl" target="_blank">Privacy Collection Notice</a> and agree to the collection, use and storage of my
                personal information as set out in it; and
              </li>
              <li>
                consent to my information being checked with the document issuer or official record holder via third party systems for the
                purpose of confirming my identity, and to a credit check being performed by a credit reporting agency.
              </li>
            </ul>
            <p>
              If you do not agree to our online verification process you can contact us using the details below to complete your finance
              application.
            </p>
          </div>
        </div>
      </div>
      <br />
      <div class="q-px-md q-py-md text-center">
        <QBtn color="primary" type="submit" no-caps :disable="!checked" :loading="loading">Continue</QBtn>
      </div>
    </QForm>
    <IDScanDialog v-if="showIDScanDialog" @close="closeIDScanDialog" />
  </div>
</template>

<script>
import { QBtn, QForm, QCheckbox } from 'quasar';
import { GlobalDialog } from '../../components/Dialogs/GlobalDialog';
import IDScanDialog from '../IDScan/Index.vue';
import { mapGetters } from 'vuex';
import ColoureMixins from '../../mixins/ColourMixins.js';

export default {
  name: 'IDVerifLanding',
  mixins: [ColoureMixins],
  // components: { QBtn, QForm, QCheckbox, IDScanDialog },
  components: { QBtn, QForm, IDScanDialog },
  props: [],
  created() {},
  data: function () {
    return {
      checked: true,
      showIDScanDialog: false,
      loading: false,
      showIDScanHome: false
    };
  },

  computed: {
    ...mapGetters({
      whiteLabel: 'theme/getWhitelabel',
      scoreboard: 'theme/getScoreboard'
    }),
    convertColourComputed() {
      return this.convertColour();
    },
    privacyPolicy() {
      return this.whiteLabel.privacyPolicy || 'https://eclipxgroup.com/privacy-policy/';
    },
    consentUrl() {
      return 'https://assets.fleetpartners.com.au/legal/documents/FleetPartners-Privacy-Collection-Notice.pdf';
    }
  },

  methods: {
    onSubmit: async function () {
      this.loading = true;
      this.showIDScanDialog = true;
      this.loading = false;
    },
    closeIDScanDialog: function (value = null) {
      this.showIDScanDialog = false;

      if (value && value == 'passed') {
        setTimeout(() => {
          this.$emit('onIDScanPassed');
        });
      } else if (value && value == 'failed') {
        this.$router.go();
      }
    },
    openDialog: function (param) {
      if (param == 'device' || param == 'identity') {
        this.$euiNotifications.emit({
          notification: GlobalDialog,
          noEscDismiss: true,
          persistent: true,
          body:
            param == 'device'
              ? '<span style="color:white">A device with a camera is needed to scan your identity document and capture its details.</span>'
              : '<span style="color:white">Your current driver\'s licence will be needed to verify your identity.</span>',
          qCardStyle: {
            padding: '0',
            width: '400px',
            maxWidth: '80vw',
            backgroundColor: 'var(--primary-color)'
          },
          closeBtnStyle: {
            color: 'white'
          }
        });
      }
    }
  }
};
</script>
